<template>
	<div class="nut-tool-wrap">
		<slot></slot>
		<transition name="fade">
			<div v-if="visiable" class="nut-tool-tips">{{ content }}</div>
		</transition>
	</div>
</template>

<script type="text/jsx">
export default {
	name: 'tool-tip',

	computed: {
		vi () {
			return this.visiable
		},
		toolStyle () {
			return `width: ${this.width}px; margin-left: -${this.width / 2 + 5}px`
		}
	},
	props: {
		toolShow: {
			type: Boolean,
			default: true
		},
		width: {
			type: Number,
			default: 240
		},
		content: {
			type: String
		},
		visiable: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
.nut-tool-wrap {
	position: relative;
	z-index: 10;
}
.nut-tool-tips {
	position: absolute;
	left: 0;
	transform: translateX(-50%);
	bottom: calc(100% + 10px);
	max-width: 300px;
	min-width: 200px;
	background-color: #224a6d;
	border-radius: 4px;
	color: #fff;
	line-height: 18px;
	padding: 5px 10px;
	font-size: 12px;
}
.nut-tool-tips {
	&::before {
		content: '';
		position: absolute;
		opacity: 0.9;
		left: 50%;
		bottom: -8px;
		border-style: solid;
		border-width: 8px 8px 0 8px;
		border-color: #224a6d transparent transparent transparent;
		z-index: -1;
	}
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
